import axios from "axios";
import qs from "qs";
const initialState = {
    dayOfSharesData: [],
};

export const state = { ...initialState };

export const actions = {
    async loadSharesData(context) {
        return axios.get("/api/shares", {
        }).then(function (response) {
            context.commit("setDayOfSharesData", response.data);
        });
    },

}

export const mutations = {
    setDayOfSharesData(state, dayOfSharesData) {

		for(var i=0; i<dayOfSharesData.length; i++){

			dayOfSharesData[i]["valuation"] = dayOfSharesData[i].num_of_shares * dayOfSharesData[i].price_per_share;

		}
        state.dayOfSharesData = dayOfSharesData;
    },
}

const getters = {
    dayOfSharesData(state) {
        return state.dayOfSharesData;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
